import { atom } from "recoil";

export interface ShowPlayer {
    show: boolean;
}

export const ShowPlayerState = atom({
    key: "showPlayer",
    default: false,
});